
import { Component, Prop, Vue} from "vue-property-decorator";
import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffold.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffold.vue";
import PostingModalWithButton from "@/components/postings/PostingModalWithButton.vue";
import RecruitingIcon from "@/components/icons/RecruitingIcon.vue";
import JobPostingIcon from "@/components/icons/JobPostingIcon.vue";
import RouteNames from "@/entities/RouteNames";
import GET_DASHBOARD_REQUESTS from "@/apollo/dashboard/GetDashboardRequests.gql";
import CustomRequestModal from "@/components/requests/CustomRequestModal.vue";
import UiButton from "@/components/button/ui-button.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import SimplePersonIcon from "@/components/icons/SimplePersonIcon.vue";
import commonContractorRequestConditions from "@/data/contractorReguests/commonContractorRequestConditions";
import getFullName from "@/helpers/getFullName";
import { Manager_Contractor } from "@/generated/graphql";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
import ItemChipsData from "@/entities/ItemChipsData";

@Component({
  components: {
    ItemChipsWithMore,
    SimplePersonIcon,
    PlusIcon,
    UiButton,
    CustomRequestModal,
    DashboardCardScaffold,
    PostingModalWithButton,
    CardItemScaffold,
    JobPostingIcon,
    RecruitingIcon,
  },
  apollo: {
    requests: {
      variables() {
        return {
          contractorRequestConditions: {
            _and: commonContractorRequestConditions,
          }
        };
      },
      query: GET_DASHBOARD_REQUESTS,
      update(data) {
        this.customRequestsCount = data.custom_request_aggregate.aggregate.count;
        this.contractorRequestsCount = data.manager_contractor_aggregate.aggregate.count;
        this.contractors = data.manager_contractor;
      }
    }
  }
})
export default class DashboardRequest extends Vue {
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({type: String, required: true}) readonly currentUserId!: string;

  routes = RouteNames;

  customRequestsCount: number = 0;
  contractorRequestsCount: number = 0;
  contractors: Manager_Contractor[] = [];
  modalShown: boolean = false;

  get contractorsInfo(): ItemChipsData[] {
    if (!this.contractors.length) {
      return [];
    }

    return this.contractors.map(({ contractor }) => {
      const { given_name, family_name } = contractor.user;

      return {
        name: getFullName(given_name!, family_name!),
        avatar: contractor.user.avatar,
        id: contractor.user.id,
        routeParams: {
          name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
          params: { id: contractor.user.id }
        }
      };
    });
  }
}
